// extracted by mini-css-extract-plugin
module.exports = {"tag":"dh-dh-orderud-faq-tag","orderudInverted":"dh-dh-orderud-faq-orderudInverted","tagWrapper":"dh-dh-orderud-faq-tagWrapper","viewAll":"dh-dh-orderud-faq-viewAll"};